import React from 'react';
import { Accordion, Badge } from 'react-bootstrap';

import { Comunicacao } from '../../modules/types/Comunicacao';

type StatusChave = 'respondido' | 'visualizado' | 'nao_visualizado';

type StatusParser = Record<StatusChave, [string, string]>;

type Props = {
  comunicacao: Comunicacao;
};

const ComunicacaoItem: React.FC<Props> = ({ comunicacao }) => {
  const statusParser: StatusParser = {
    respondido: ['Respondido', 'success'],
    visualizado: ['Visualizado', 'warning'],
    nao_visualizado: ['Não visualizado', 'danger'],
  };

  const [statusLabel, statusColor] = statusParser[comunicacao.status];

  return (
    <Accordion.Item
      eventKey={String(comunicacao.id)}
      style={{
        border: '1px solid black',
        padding: '10px',
        backgroundColor: '#eaf2f9',
        fontSize: '0.95rem',
      }}
    >
      <Accordion.Header>
        <div style={{ width: '100%' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              fontWeight: 'bold',
              paddingBottom: '4px',
              borderBottom: '1px solid black',
            }}
          >
            <div>
              <span style={{ marginRight: '6px' }}>
                ID: <strong>{comunicacao.id}</strong>
              </span>
              <span>{comunicacao.responsaveis}</span>
            </div>
            <div style={{ fontStyle: 'italic', fontWeight: 'normal' }}>
              Enviado em: {comunicacao.dataEnvio} — Editado em:{' '}
              <span style={{ fontStyle: 'italic' }}>
                {comunicacao.editado ? 'Hoje' : 'Não editado'}
              </span>
            </div>
          </div>
        </div>
      </Accordion.Header>
      <Accordion.Body style={{ backgroundColor: '#eaf2f9' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>
            <p>
              <strong>Assunto:</strong>{' '}
              <span style={{ fontWeight: 'bold' }}>{comunicacao.assunto}</span>
            </p>
            <p>
              <strong>Tipo:</strong>{' '}
              <span style={{ fontWeight: 'bold' }}>{comunicacao.tipo}</span>
            </p>
          </div>
          <div>
            <p>
              <strong>Requer retorno da outra parte?</strong>{' '}
              <span style={{ fontWeight: 'bold' }}>
                {comunicacao.requerRetorno ? 'Sim' : 'Não'}
              </span>
            </p>
            <p>
              <strong>Status:</strong>{' '}
              <Badge bg={statusColor}>{statusLabel}</Badge>
            </p>
          </div>
        </div>
        <div>
          <p>
            <strong>Mensagem:</strong>
          </p>
          <p style={{ textAlign: 'justify' }}>{comunicacao.mensagem}</p>
        </div>
        <div
          style={{
            textAlign: 'right',
            fontSize: '0.9rem',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: '5px',
          }}
        >
          <span>{comunicacao.visualizacoesUnicas}</span>
          <i className="bi bi-eye"></i>
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
};

export default ComunicacaoItem;
